import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { PowertrainWizard } from './PowertrainWizard';
import './style.scss';
import HierarchyComponent from './Hierarchy/HierarchyComponent';

const PowertrainConfigurationComponent = ({
    actions,
    model
}) => {

    const {
        filteredPowertrains,
        selectedPowertrain,
        searchboxFilter,
        sites,
        selectedSites,
        organizations,
        hierarchyData,
        selectedHierarchyNodes,
        hierarchyExpandedNodes,
        isEditHierarchy,
        hierarchyRequestData,
        hierarchySelectedAssets,
        updateHierarchyLoadingStatus,
        hierarchyErrorModalVisible,
        isSaveFailed,
        isPartialPowertrainFailure,
        conversionResult
    } = model;
    const {
        setSelectedPowertrain,
        deletePowertrainRequest,
        convertToLocationRequest,
        setPowertrainForEditing,
        updateHierarchyDataRequest,
        setSelectedHierarchyNodes,
        setHierarchyExpandedNodes,
        setIsEditHierarchy,
        setHierarchyRequestData,
        setHierarchySelectedAssets,
        getHierarchyDataRequest,
        setHierarchyErrorModal,
        setSaveFailed,
        setPartialPowertrainFailure,
        clearConversionResult
    } = actions;
    const [powertrainWizardVisible, setPowertrainWizardVisible] = useState(false);
    const [wizardSelectedNode, setWizardSelectedNode] = useState(null);
    const prevOrganizationsRef = useRef(null);

    useEffect(() => {
        const currentOrg = JSON.stringify(organizations);
        if (prevOrganizationsRef.current !== null && prevOrganizationsRef.current !== currentOrg) {
            setPowertrainWizardVisible(false);
            setSelectedPowertrain(null);
        }
        prevOrganizationsRef.current = currentOrg;
    }, [organizations]);

    if (powertrainWizardVisible) {
        return (
            <PowertrainWizard
                show={powertrainWizardVisible}
                close={() => {
                    setPowertrainWizardVisible(false);
                    setWizardSelectedNode(null);
                }}
                selectedNodeData={wizardSelectedNode}
                hierarchyData={hierarchyData}
            />
        );
    }

    return (
        <HierarchyComponent
            hierarchyData={hierarchyData}
            filteredPowertrains={filteredPowertrains}
            selectedPowertrain={selectedPowertrain}
            searchboxFilter={searchboxFilter}
            sites={sites}
            selectedSites={selectedSites}
            organizations={organizations}
            setSelectedPowertrain={setSelectedPowertrain}
            deletePowertrainRequest={deletePowertrainRequest}
            convertToLocationRequest={convertToLocationRequest}
            setPowertrainForEditing={setPowertrainForEditing}
            setPowertrainWizardVisible={setPowertrainWizardVisible}
            setWizardSelectedNode={setWizardSelectedNode}
            getHierarchyDataRequest={getHierarchyDataRequest}
            updateHierarchyDataRequest={updateHierarchyDataRequest}
            selectedHierarchyNodes={selectedHierarchyNodes}
            hierarchyExpandedNodes={hierarchyExpandedNodes}
            isEditHierarchy={isEditHierarchy}
            hierarchyRequestData={hierarchyRequestData}
            hierarchySelectedAssets={hierarchySelectedAssets}
            setSelectedHierarchyNodes={setSelectedHierarchyNodes}
            setHierarchyExpandedNodes={setHierarchyExpandedNodes}
            setIsEditHierarchy={setIsEditHierarchy}
            setHierarchyRequestData={setHierarchyRequestData}
            setHierarchySelectedAssets={setHierarchySelectedAssets}
            updateHierarchyLoadingStatus={updateHierarchyLoadingStatus}
            hierarchyErrorModalVisible={hierarchyErrorModalVisible}
            isSaveFailed={isSaveFailed}
            isPartialPowertrainFailure={isPartialPowertrainFailure}
            setHierarchyErrorModal={setHierarchyErrorModal}
            setSaveFailed={setSaveFailed}
            setPartialPowertrainFailure={setPartialPowertrainFailure}
            conversionResult={conversionResult}
            clearConversionResult={clearConversionResult}
        />
    );
};

PowertrainConfigurationComponent.propTypes = {
    model: PropTypes.shape({
        filteredPowertrains: PropTypes.array,
        powertrainsLoadingStatus: PropTypes.string,
        selectedPowertrain: PropTypes.any,
        organizations: PropTypes.array,
        powertrainsCurrentPage: PropTypes.number,
        hasMorePowertrains: PropTypes.bool,
        sites: PropTypes.array,
        selectedSites: PropTypes.array,
        hierarchyData: PropTypes.object,
        selectedHierarchyNodes: PropTypes.array,
        hierarchyExpandedNodes: PropTypes.array,
        isEditHierarchy: PropTypes.bool,
        hierarchyRequestData: PropTypes.array,
        hierarchySelectedAssets: PropTypes.array,
        updateHierarchyLoadingStatus: PropTypes.string,
        hierarchyErrorModalVisible: PropTypes.bool,
        isSaveFailed: PropTypes.bool,
        isPartialPowertrainFailure: PropTypes.bool,
        conversionResult: PropTypes.shape({
            siteId: PropTypes.number,
            locationId: PropTypes.number,
            locationName: PropTypes.string,
            showBanner: PropTypes.bool
        }),
        searchboxFilter: PropTypes.string,
        generalFilterLoadingStatuses: PropTypes.array,
        hierarchyDataLoadingStatus: PropTypes.string
    }),
    actions: PropTypes.shape({
        setSelectedPowertrain: PropTypes.func,
        deletePowertrain: PropTypes.func,
        setPowertrainForEditing: PropTypes.func,
        deletePowertrainRequest: PropTypes.func,
        setHierarchyErrorModal: PropTypes.func,
        setSaveFailed: PropTypes.func,
        setPartialPowertrainFailure: PropTypes.func,
        convertToLocationRequest: PropTypes.func,
        clearConversionResult: PropTypes.func,
        updateHierarchyDataRequest: PropTypes.func,
        setSelectedHierarchyNodes: PropTypes.func,
        setHierarchyExpandedNodes: PropTypes.func,
        setIsEditHierarchy: PropTypes.func,
        setHierarchyRequestData: PropTypes.func,
        setHierarchySelectedAssets: PropTypes.func,
        getHierarchyDataRequest: PropTypes.func,
        initializeDataRequest: PropTypes.func,
        clearStore: PropTypes.func
    })
};

export default PowertrainConfigurationComponent;
